import React from 'react'
import { Form, IFormValues } from '../../elements/Form'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'
import { IFieldValue, IFormField } from '../../elements/Form/@types/FormField'
import { IProps } from './index'
import { Color, getVariable, Icon } from '../../utils'
import { useGetFromSessionStorage } from '../../hooks/use-session-storage'

export const FlowSelector: React.FC<IProps> = ({ title, flowOptions }) => {
  const { translate } = useTranslate()
  const [getFromSessionStorage] = useGetFromSessionStorage()

  const getFields = (): IFieldValue[] =>
    flowOptions.map((option) => {
      const { label, url } = option
      const { tag: labelTag, value: labelValue } = getVariable(label)
      const { tag: urlTag, value: urlValue } = getVariable(url)
      let parsedLabel = label
      if (labelTag && labelValue) {
        const storedValue = getFromSessionStorage(`query.${labelValue}`)
        parsedLabel = storedValue ? label.replace(labelTag, storedValue) : ''
      }
      let parsedUrl = url
      if (urlTag && urlValue) {
        const storedValue = getFromSessionStorage(`query.${urlValue}`)
        parsedUrl = storedValue ? url.replace(urlTag, storedValue) : ''
      }

      return { label: parsedLabel, value: parsedUrl }
    })

  const formFields: IFormField[] = [
    {
      id: 'flow',
      type: 'radioButtons',
      required: true,
      values: getFields(),
    },
  ]

  return (
    <>
      <div className="flow-form">
        <Form
          fields={formFields}
          submitButtonLabel={translate('Next')}
          icon={Icon.Arrow}
          headingText={title}
          headingSize="heading-5"
          backgroundColor={Color.Gray}
          disableSubmitOnEmptyForm={true}
          theme="rounded"
          onSubmit={async (values: IFormValues) => {
            window.location.assign(values.flow)
            return { success: true }
          }}
        />
        <style jsx>{`
          .flow-form {
            :global(.form-field) {
              :global(div.radio-button-group) {
                grid-template-areas: unset;
                grid-template-columns: unset;

                > :global(label) {
                  grid-area: unset;
                }
              }
            }
          }
        `}</style>
      </div>
    </>
  )
}
